<template>
    <template v-if="showPromotion && data?.imageUrl">
        <component :is="data?.imageLink ? MiscLink : 'template'" :to="data?.imageLink">
            <MiscImage
                :src="data.imageUrl"
                :alt="data.title || ''"
                class="m-auto"
                width="608"
                sizes="608px md:297px lg:309px xl:395px 2xl:608px"
                lazy-load
            />
        </component>
    </template>
</template>

<script setup lang="ts">
import { MiscLink } from '#components'
const detailPromotionData = inject<Ref>('detailPromotionData')
const { showPromotion, computedPromotionData: data } = useDetailPromotion(detailPromotionData)
</script>
